import { alertsActions } from '.';
import getErrorMessage from 'utils/getErrorMessage';
import { assigneesConstants } from 'store/constants';
import { assigneesServices } from 'store/services/assignees.service';

const loadAssignees = () => {
  const request = () => ({
    type: assigneesConstants.ASSIGNEES_REQUEST,
  });
  const success = (assignees) => ({
    type: assigneesConstants.ASSIGNEES_SUCCESS,
    payload: {
      assignees,
    },
  });
  const failure = (error) => ({
    type: assigneesConstants.ASSIGNEES_ERROR,
    payload: {
      error,
    },
  });
  return async (dispatch) => {
    dispatch(request());
    try {
      const data = await assigneesServices.loadAssignees();
      dispatch(success(data));
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      dispatch(failure(errorMessage as string));
      dispatch(alertsActions.error(errorMessage));
    }
  };
};

export const assigneesActions = {
  loadAssignees,
};
